import { render, staticRenderFns } from "./CustomerVerificationSummary.vue?vue&type=template&id=f4ac3b12&scoped=true&"
import script from "./CustomerVerificationSummary.vue?vue&type=script&lang=js&"
export * from "./CustomerVerificationSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ac3b12",
  null
  
)

export default component.exports